<!-- <div *ngIf="!shop_category_2" [ngClass]="['banner__area', style_2 ? 'pt-20' : '', style_3 ? 'pt-20' : '', style_4 ? 'pt-30' : '']">
  <div [ngClass]="['container-fluid', style_3 ? 'custom-container' : '']">
    <div [ngClass]="[style_2 ? '' : (!style_3 && !style_4 ? 'banner__inner p-relative mt--95 z-index-1' : ''), style_4 ? 'banner__inner-2 p-relative' : '']">
      <div class="row">
        <div *ngFor="let item of category_data" class="col-xl-2 col-lg-2 col-md-6">
          <div class="banner__item mb-30 p-relative cust-border">
            <div class="banner__thumb fix">
              <a [routerLink]="['/shop']" [queryParams]="{category: item.id}" class="w-img">
                <img [src]="(item.image)?imagePath+item.image:'/assets/img/shop/banner/banner-sm-1.jpg'" alt="banner" />
              </a>
            </div>
            <div class="banner__content p-absolute transition-3">
              <h5>
                <a [routerLink]="['/shop']" [queryParams]="{category: item.id}" [innerHTML]="item.title"></a>
              </h5>
              <a [routerLink]="['/shop']" [queryParams]="{category: item.id}" class="link-btn">Discover now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->


<div *ngIf="!shop_category_2" [ngClass]="['banner__area', style_2 ? 'pt-20' : '', style_3 ? 'pt-20' : '', style_4 ? 'pt-30' : '']">
  <div [ngClass]="['container-fluid', style_3 ? 'custom-container' : '']">
    <div [ngClass]="[style_2 ? '' : (!style_3 && !style_4 ? 'banner__inner p-relative mt--95 z-index-1' : ''), style_4 ? 'banner__inner-2 p-relative' : '']">
      <div class="row">
        <div *ngFor="let item of category_data" class="col-xl-2 col-lg-2 col-md-6">
          <div class="banner__item mb-30 p-relative cust-border align-items-center justify-content-center  d-flex">
            <div class="banner__content p-absolute transition-3">
              <h4>
                <a class="link-dark" [routerLink]="['/shop']" [queryParams]="{category: item.id}" [innerHTML]="item.title"></a>
              </h4>
              <a [routerLink]="['/shop']" [queryParams]="{category: item.id}" class="link-btn">Discover now</a>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- banner__area-df start -->
<!-- <div *ngIf="shop_category_2" class="banner__area-df mt-10">
  <div *ngFor="let item of category_data.slice(3, 6)" class="banner__item-3 mb-30">
      <div class="banner__item-3-image m-img">
          <img [src]="item.img" alt="category-img">
      </div>
      <div class="banner__content-5">
          <h5>{{item.parentTitle}}</h5>
          <p>{{item.smDesc}}</p>
          <a [routerLink]="['/shop']" [queryParams]="{category: utilsService.convertToURL(item.parentTitle)}" class="os-btn-5">Shop Now</a>
      </div>
  </div>
</div> -->
<!-- banner__area-df end -->
